import type { App } from 'vue'

import type { VuePlugins } from './types'

import { extractPluginNameFromPath, sortArrayByReferenceArray } from './utils'

export { defineVuePlugin } from './utils'

export async function installVuePlugins(app: App, pluginsOrder: string[] = [], excludedPlugins: string[] = []) {
  const plugins = import.meta.glob('@/app/plugins/*/index.ts', { eager: true }) as VuePlugins
  const pluginsNormalized = extractPluginNameFromPath(plugins)
  const pluginNames = Object.keys(pluginsNormalized).filter((name) => !excludedPlugins.includes(name))
  const sortedPluginNames = sortArrayByReferenceArray(pluginNames, pluginsOrder)
  let pluginName: keyof typeof pluginsNormalized
  for (pluginName of sortedPluginNames) {
    await pluginsNormalized[pluginName].default(app)
  }
}
